// extracted by mini-css-extract-plugin
export default {"albums":"AlbumPage_albums__AdFCz"};